import { useCallback, useEffect, useState } from "react";
import { WarehouseAPI } from "@/apis/material";
import { Select } from "@arco-design/web-react";
import _ from "lodash";
import { debounce } from "lodash";
import { Button, Divider } from "@arco-design/web-react";
import { Link } from "react-router-dom";

const WarehouseSelect = (props) => {
    const { type, addLink, includeUnavailable = false, ...restProps } = props;
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const getOptions = async () => {
            const values = await WarehouseAPI.actives(includeUnavailable);
            const opts = _.map(_.orderBy(values, ['warehouseName'], ['asc']), (item) => ({
                value: item.id,
                label: item.warehouseName
            }));
            setOptions(opts);
        }

        getOptions();
    }, [type, includeUnavailable]);

    return (
        <Select {...restProps}
            showSearch
            filterOption={(inputValue, option) =>
                _.toLower(option.props.value).indexOf(inputValue.toLowerCase()) >= 0 ||
                option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            dropdownRender={(menu) => (
                <div>
                    {menu}
                    {addLink &&
                        <>
                            <Divider style={{ margin: 0 }} />
                            <Link to={`/workspace/settings/warehouse`}>
                                <Button type="text" size="small" style={{ marginLeft: 22, padding: '6px 0' }}>Add Warehouse</Button>
                            </Link>
                        </>
                    }
                </div>
            )}
            options={options}
            onChange={(val) => props.onChange && props.onChange(val)}>
        </Select>
    );
}

const UILocationSelect = (props) => {
    const { warehouseId, onlyActive, ...restProps } = props;
    const [options, setOptions] = useState([]);
    const [onlyActiveLocations] = useState(onlyActive ?? true);

    const getOptions = useCallback(async (locationName) => {
        const search = debounce(async (warehouseId, locationName) => {
            if (warehouseId) {
                if (onlyActiveLocations) {
                    const values = await WarehouseAPI.activeLocations(warehouseId, locationName);
                    setOptions(_.map(_.orderBy(values, ['name'], ['asc']), (item) => ({
                        value: item.id,
                        label: item.name
                    })));
                } else {
                    const values = await WarehouseAPI.locations(warehouseId, locationName);
                    setOptions(_.map(_.orderBy(values.records, ['name'], ['asc']), (item) => ({
                        value: item.id,
                        label: item.name
                    })));
                }
            }
        }, 100);
        await search(warehouseId, locationName);
    }, [warehouseId, onlyActiveLocations]);

    useEffect(() => {
        getOptions();
    }, [getOptions]);

    return (
        <Select {...restProps}
            showSearch
            allowClear
            filterOption={false}
            onSearch={(val) => {
                getOptions(val);
            }}
            options={options}
            onChange={(val, option) => {
                const label = option ? option.children : null;
                props.onChange && props.onChange(val, label);
            }}>
        </Select>
    );
}

WarehouseSelect.LocationSelect = UILocationSelect;

export default WarehouseSelect;
